// This list tracks which languages should display in Right-to-Left format by default
// When a new language is added, be sure to update this list.

// These values are intentionally hard-coded

// Should the following language be displayed in RTL by default?
// 'ar-EG' yes
// 'ar-JO' yes
// 'bg-BG'
// 'cs-CZ'
// 'da-DK'
// 'de-DE'
// 'el-GR'
// 'en-US'
// 'es-ES'
// 'fi-FI'
// 'fr-FR'
// 'he-IL' yes
// 'hu-HU'
// 'it-IT'
// 'ja-JP'
// 'ko-KR'
// 'lv-LV'
// 'nb-NO'
// 'nl-NL'
// 'pl-PL'
// 'pt-BR'
// 'pt-PT'
// 'ru-RU'
// 'sv-SE'
// 'tr-TR'
// 'zh-HANS'
// 'zh-HANT'
// 'zh-YUE'

export default function getRTLList() {
  const rtlList = ['ar-EG', 'ar-JO', 'ar-SA', 'he-IL'];

  return rtlList;
}
